import React from "react";
import { useGame } from "../../contexts/GameContext";
import { Coins, Sparkles, Layers } from "lucide-react";

export const TopBar = ({ children, "data-testid": testId }) => {
  const { character, floor } = useGame();
  if (!character) return null;
  return (
    <div data-testid={testId} className="flex items-center gap-3 px-4 py-3 bg-slate-800 border-b-4 border-slate-950">
      <div className="bg-sky-400 text-slate-950 border-4 border-slate-950 rounded-xl px-3 py-1.5 font-display font-bold flex items-center gap-2 cartoon-shadow-static">
        <Layers className="w-4 h-4" />
        <span data-testid="floor-indicator">Étage {floor}</span>
      </div>
      <div className="bg-yellow-400 text-slate-950 border-4 border-slate-950 rounded-xl px-3 py-1.5 font-display font-bold flex items-center gap-2 cartoon-shadow-static">
        <Coins className="w-4 h-4" />
        <span data-testid="gold-indicator">{character.gold}</span>
      </div>
      <div className="bg-fuchsia-400 text-slate-950 border-4 border-slate-950 rounded-xl px-3 py-1.5 font-display font-bold flex items-center gap-2 cartoon-shadow-static">
        <Sparkles className="w-4 h-4" />
        <span data-testid="passives-indicator">{character.passifs?.length || 0} passifs</span>
      </div>
      <div className="ml-auto flex items-center gap-3">{children}</div>
    </div>
  );
};
